import { AutocompleteInput } from "@/components/admin";
import { Card } from "@/components/ui/card";
import {
  DataTable,
  DateField,
  DateInput,
  List,
  ListActions,
  NeutralBadge,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  TextField,
} from "../common";

const statusChoices = [
  { id: "present", name: "Present" },
  { id: "absent", name: "Absent" },
  { id: "half_day", name: "Half Day" },
  { id: "leave", name: "Leave" },
  { id: "holiday", name: "Holiday" },
  { id: "weekoff", name: "Weekoff" },
];

const filters = [
  <ReferenceInput key="employee_id" source="employee_id" reference="employees">
    <AutocompleteInput label="Employee" optionText="name" />
  </ReferenceInput>,
  <DateInput key="date" source="date" />,
  <SelectInput key="status" source="status" choices={statusChoices} />,
];

export const AttendanceList = () => (
  <List
    title="Attendance"
    filters={filters}
    actions={<ListActions label="Add Attendance" />}
    sort={{ field: "date", order: "DESC" }}
  >
    <Card className="border border-border rounded-xl bg-card shadow-sm overflow-hidden">
      <DataTable rowClick="edit">
        <DataTable.Col label="Employee">
          <ReferenceField source="employee_id" reference="employees" link={false}>
            <TextField source="name" className="font-semibold" />
          </ReferenceField>
        </DataTable.Col>
        <DataTable.Col source="date" label="Date">
          <DateField source="date" />
        </DataTable.Col>
        <DataTable.Col label="Status">
          <NeutralBadge />
        </DataTable.Col>
        <DataTable.Col source="check_in" label="Check In">
          <DateField source="check_in" showTime />
        </DataTable.Col>
        <DataTable.Col source="check_out" label="Check Out">
          <DateField source="check_out" showTime />
        </DataTable.Col>
        <DataTable.Col source="hours_worked" label="Hours" />
      </DataTable>
    </Card>
  </List>
);
